"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Tab = require("./Tab.styles");

var _elements = require("../../../styles/elements");

var Container = (0, _base["default"])("button", {
  target: "e2y7laj0",
  label: "Container"
})(_elements.button.styles.preflight, ";", _Tab.styles.tab, ";");

var Tab = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
      itemKey = _ref.itemKey,
      type = _ref.type,
      children = _ref.children,
      active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className;
  var handleClick = (0, _react.useCallback)(function () {
    onClick(itemKey);
  }, [itemKey, onClick]);
  return (0, _jsxRuntime.jsx)(Container, {
    type: "button",
    className: (0, _clsx["default"])('grui', className),
    tabType: type,
    active: active,
    disabled: disabled,
    ref: ref,
    onClick: handleClick,
    children: children
  });
});

Tab.propTypes = {
  className: _propTypes.string,
  type: (0, _propTypes.oneOf)(['big', 'small']),
  onClick: _propTypes.func,
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,
  itemKey: _propTypes.string,
  active: _propTypes.bool
};
Tab.defaultProps = {
  className: undefined,
  type: 'big',
  onClick: function onClick() {},
  disabled: false,
  itemKey: undefined,
  active: undefined
};
Tab.displayName = 'Tab';
var _default = Tab;
exports["default"] = _default;
//# sourceMappingURL=Tab.js.map